import styled from "styled-components";
import { ArrowRight, ServicesBg } from "../../../ui/AllImages";



export const ServiceWrapper = styled.section`
    background-image: url(${ServicesBg});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .heading-text{
        width:80%;
    }
    .service-card{
        display:flex;
        padding: 25px 0 25px  15px;
        border-radius: 10px;
        background-color: var(--white);
       
        background-position: right top;
        background-repeat: no-repeat;
        flex-direction: column;
        gap: 10px;
        gap:12px;
        margin:15px 0;
        height:168px;
        width:100%;
        &>span{
            svg{
                height:54px;
            }
        }
        & p{
            font-size:14px;
        }
    }
`
export const AchivementWrapper = styled.section`

    background-color:var(--bg);
    .item-container{
        background-image: url(${ServicesBg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-color: var(--themeColor);
        background-position: right bottom;
        background-repeat: no-repeat;
        flex-wrap: nowrap;
        border-radius: 10px;
        /* margin: 10px 0; */
        padding: 32px 32px 32px 20px;
        position: relative;
    }
    #services & .item-box{
        position:relative;
        color:var(--text2);
        padding: 10px 25px 10px 16px;
        background-color: #162E2F;
        border-radius: 12px;
        font-family: var(--familyRbtFlex) !important;
        font-weight: var(--regular) !important;
        font-size: 18px;
        display: flex;
        align-items: center;
        gap: 8px;
        line-height: 1.3;
        /* &::after{
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            right: 10px;
            top: 5px;
            background-image: url(${ArrowRight});
            background-size: 100%;

        } */
            
        
    }
    
    #services & .active-item-box{
        background-color: var(--secondaryColor);
        font-family: var(--familyRbtFlex) !important;
        font-weight: var(--bold) !important;
        color: var(--themeColor);
        .navTabNumber{
           background-color: #E5C89B;
            border-radius: 8px;
            color: var(--themeColor);
        }
    }
    
    .navTabNumber{
        display: flex;
        width: 32px;
        height: 32px;
        align-items: center;
        justify-content: center;
        font-family: var(--familyRbt) !important;
        font-weight: var(--regular);
        font-size: 16px;
        background-color: var(--text);
        border-radius: 8px;
        color: var(--text2);
    }
    .service-content-number{
        display: flex;
        position: absolute;
        right: -80px;
        top: 40px;
        font-family: var(--familyRbt) !important;
        font-weight: var(--extraBold);
        font-size: 150px;
        color: rgba(255, 255, 255, 0.1);
        line-height: 1;
        z-index: -1;
    }
    .item-container-left{
        min-width: 357px;
        max-width: 357px;
    }

    .serArrowList{
        display: flex;
        min-width: 20px;
        max-width: 20px;
        padding-top: 3px;
    }

    .service-solution-data-container{
        position: relative;
        padding: 25px;
        background-position: right bottom !important;
        background-repeat: no-repeat !important;
        z-index: 5;
        .service-list-container{
            
        }
        
    }
    .ssd-wrapper{
        width: calc(75% - 100px);
    }
    &.serviceArchiveSec{
        padding-top: 70px;
        padding-bottom: 0;
    }
    body.rtl #services &{
        .item-box{
            font-family: var(--arRegular) !important;
            font-weight: var(--regular) !important;
            font-size: 18px;
            padding: 10px 16px 10px 25px;
        }
        .active-item-box{
            font-family: var(--arBold) !important;
            font-weight: var(--bold) !important;
            font-size: 18px;
        }
        .serArrowList{
            padding-top: 7px;
        }
        .item-container{
            padding: 32px 20px 32px 32px;
        }
        .service-content-number{
            right: auto;
            left: -80px;
        }
    }

    .mobile-view{
        display:none;
    }
    @media (max-width: 1299px) {
        .service-content-number{
            right: -30px;
        }
        body.rtl #services &{
         .service-content-number{
                right: auto;
                left: -30px;
            }   
        }
    }
    @media (max-width: 991px) {
        .item-container-left{
            min-width: 100%;
            max-width: 100%;
        }
        .item-container{
            padding: 32px 10px 32px 10px;
        }
        .main-heading-choose{
            font-size: 30px;
            margin-top: 20px;
        }
        .whyListTxt{
            font-size: 16px;
        }
        body.rtl #services &{
            .main-heading-choose{
                font-size: 30px;
                margin-top: 20px;
            }
            .item-container{
                padding: 32px 10px 32px 10px;
            }
        }

    }


`